module.exports = __webpack_public_path__ + "static/media/gonggao.b8aa8c2d.png";